var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-touch',{on:{"panup":_vm.panUp}},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"title"},[_vm._v("方法一")]),_vm._v(" "),_c('p',{staticClass:"img"}),_vm._v(" "),_c('p',{staticClass:"text"},[_c('span',{staticClass:"icon"},[_vm._v("1")]),_vm._v("点击签到领取钻石")]),_vm._v(" "),_c('p',{staticClass:"up_icon"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47792b67","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsm_month_card/get/one.vue
// module id = null
// module chunks = 